import React from "react";

import { withProjectRedirect } from "Hocs/withProjectRedirect";

import EnvironmentError from "./common/containers/EnvironmentError";

type EnvironmentProps = {
  children?: React.ReactNode;
};

const Environment = ({ children }: EnvironmentProps) => {
  return <EnvironmentError>{children}</EnvironmentError>;
};

export default withProjectRedirect(Environment);
